import { useDocTitle } from 'util/hooks'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRespondToAuthChallengeMutation } from 'util/rtk-api'
import { validatePasswordField } from 'util/password-validation'
import { AuthCard } from 'auth/auth-card'
import { showToast } from 'components/toast'

export const NewPasswordRequired = () => {
	const searchParams = useMemo(() => new URLSearchParams(window.location.search), [])
	const username = searchParams.get('username') || ''
	const session = searchParams.get('session') || ''
	const navigate = useNavigate()
	const [respondToAuthChallenge] = useRespondToAuthChallengeMutation()

	const [password, setPassword] = useState<string>('')

	const onPasswordBlur = ({ target }: { target: HTMLInputElement }) => {
		setPassword(target.value)
		validatePasswordField(target)
	}

	// Checked as it is typed, not only on blur, so Enter straight after typing cannot submit a mismatch.
	const onConfirmPasswordChange = ({ target }: { target: HTMLInputElement }) => {
		if (target.value === password) {
			target.setCustomValidity('')
			return
		}

		target.setCustomValidity(
			'This does not match the password entered above'
		)
	}

	const onFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault()

		if (!username || !session) {
			showToast('Missing challenge details. Please log in again.')
			navigate('/login')
			return
		}

		const result = await respondToAuthChallenge({
			challenge: 'NEW_PASSWORD_REQUIRED',
			session,
			username,
			newPassword: password,
		})

		if ('error' in result) {
			const data = 'data' in result.error ? result.error.data as { message?: string } : undefined
			showToast(data?.message || 'Something went wrong. Please try again.')
			return
		}

		showToast('Password set successfully', 'success')
		navigate('/dashboard')
	}

	useDocTitle('All for One - Set New Password')

	return (
		<AuthCard eyebrow="Account setup" title="Set new password" subtitle="Your account needs a new password before you can continue.">
			<form
				id="new-password-required-form"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
				<input className="auth-hidden-input"></input>

				<div className="auth-field">
					<label htmlFor="new-password" className="auth-field-label">New password</label>
					<input
						type="password"
						id="new-password"
						name="new-password"
						placeholder="New password"
						required
						onChange={({ target }) => setPassword((target as HTMLInputElement).value)}
						onBlur={onPasswordBlur}
					/>
				</div>

				<div className="auth-field">
					<label htmlFor="confirm-password" className="auth-field-label">Confirm new password</label>
					<input
						type="password"
						id="confirm-password"
						name="confirm-password"
						placeholder="Confirm new password"
						required
						onChange={onConfirmPasswordChange}
					/>
				</div>

				<button type="submit" className="auth-btn auth-btn--last">Set password</button>
			</form>
		</AuthCard>
	)
}

export default NewPasswordRequired


